import {apiVoissa} from "../../libs/api";


export const createNewsletterGuest = (data = {}, config = {}) => apiVoissa.post(`/users/accounts/signup-newsletter`, data, config);